import React from "react";

type IconProps = {
  size?: number | string;
  color?: string;
};

export const SkipForward15Icon = ({ size, color }: IconProps): JSX.Element => {
  return (
    <svg
      width={size || "24px"}
      height={size || "24px"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.51092 16.5439C6.01809 15.9758 4.7644 14.9143 3.95792 13.5356C3.15144 12.1569 2.84067 10.5438 3.07719 8.96418C3.3137 7.38452 4.08328 5.93323 5.25819 4.85118C6.43311 3.76912 7.94271 3.12137 9.53646 3.01542C11.1302 2.90948 12.7123 3.35171 14.0201 4.26872C15.3279 5.18574 16.2828 6.52239 16.7263 8.05684"
        stroke={color || "white"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0013 3V8.0915L11.9492 7.46397"
        stroke={color || "white"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9734 15.16C11.2134 15.16 11.4467 15.14 11.6734 15.1C11.9 15.06 12.1034 14.9933 12.2834 14.9C12.47 14.8067 12.6267 14.6867 12.7534 14.54C12.8867 14.3933 12.9734 14.2133 13.0134 14H13.9434V21H12.6934V16.06H10.9734V15.16ZM17.23 14H20.85V15.02H18.08L17.72 16.8L17.74 16.82C17.8933 16.6467 18.0867 16.5167 18.32 16.43C18.56 16.3367 18.7967 16.29 19.03 16.29C19.3767 16.29 19.6867 16.35 19.96 16.47C20.2333 16.5833 20.4633 16.7467 20.65 16.96C20.8367 17.1667 20.9767 17.4133 21.07 17.7C21.17 17.9867 21.22 18.2967 21.22 18.63C21.22 18.91 21.1733 19.2 21.08 19.5C20.9933 19.7933 20.85 20.0633 20.65 20.31C20.4567 20.55 20.2067 20.75 19.9 20.91C19.5933 21.0633 19.2267 21.14 18.8 21.14C18.46 21.14 18.1433 21.0933 17.85 21C17.5633 20.9133 17.31 20.78 17.09 20.6C16.87 20.42 16.6933 20.2 16.56 19.94C16.4333 19.6733 16.3633 19.3633 16.35 19.01H17.49C17.5233 19.39 17.6533 19.6833 17.88 19.89C18.1067 20.09 18.4067 20.19 18.78 20.19C19.02 20.19 19.2233 20.15 19.39 20.07C19.5567 19.99 19.69 19.88 19.79 19.74C19.8967 19.6 19.97 19.4367 20.01 19.25C20.0567 19.0633 20.08 18.8633 20.08 18.65C20.08 18.4567 20.0533 18.2733 20 18.1C19.9467 17.92 19.8667 17.7633 19.76 17.63C19.6533 17.4967 19.5133 17.39 19.34 17.31C19.1733 17.23 18.9767 17.19 18.75 17.19C18.51 17.19 18.2833 17.2367 18.07 17.33C17.8633 17.4167 17.7133 17.5833 17.62 17.83H16.48L17.23 14Z"
        fill={color || "white"}
      />
    </svg>
  );
};

export default SkipForward15Icon;
